import React from 'react';
import { ErrorMarker } from 'assets/icons';
import { Palette } from 'config';
import styled from 'styled-components';

const ErrorForBtn = ({ errorMsg, isOpen, style }) => {
  if (!isOpen) return null;
  return (
    <>
      {errorMsg && (
        <ErrorWrap style={style}>
          <ErrorMarker />
          <span>{errorMsg}</span>
        </ErrorWrap>
      )}
    </>
  );
};

export default ErrorForBtn;

export const ErrorWrap = styled.div`
  display: flex;
  align-items: center;
  text-transform: none;
  margin-top: 8px;
  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: ${Palette.Red._500};
    margin-left: 8px;
  }
`;
